module.exports = __webpack_public_path__ + "static/media/thumb.597f7aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/cambridge-student-accommodation/thumb.jpg
// module id = 40
// module chunks = 0